export type SubmitPaymentPayload = {
  pointsRedeem: number;
  amountUsd: number;
  email?: string;
  billingAddress?: OrderAddressPayload;
  shippingAddress?: OrderAddressPayload;
};
export type AmountPayload = {
  amountUsd: number;
  amountPoints: number;
};
export type SubmitPayloadId = {
  payloadId?: string;
};
export type OrderPlacingResponse = {
  number?: string;
  confirmationNumber?: string;
  errors?: string[];
};

export interface OrderAddressPayload {
  city: string;
  countryCode: string;
  postalCode: string;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  stateCode: string;
}

export type PlaceOrderPayload = {
  amount: AmountPayload;
  payment?: SubmitPayloadId | null;
  email: string;
  shippingAddress: OrderAddressPayload;
  billingAddress: OrderAddressPayload;
};

export enum PlaceOrderHeaderEnum {
  CaptureContext = 'X-Capture-Context',
  TransientToken = 'X-Transient-Token',
}
